import { NgModule } from '@angular/core';

import { SharedUiModule } from '@sd-portal/shared/ui';
import { SharedDirectivesModule } from '@sd-portal/shared/directives';
import { SharedPipesModule } from '@sd-portal/shared/pipes';

import { PaginationComponent } from './components/pagination/pagination.component';

@NgModule({
  declarations: [PaginationComponent],
  imports: [SharedPipesModule, SharedDirectivesModule, SharedUiModule],
  exports: [PaginationComponent]
})
export class SharedUtilModule {}
